import React from 'react'
import useFirestore from '../hooks/useFirestore'
import useImageSource from '../hooks/useImageSource'
import Bounce from 'react-reveal/Bounce';
import { getThumbUrl, handleImageError } from '../utils/imageHelper';

const ImageGrid = ({ setSelectedImg }) => {
    const { docs } = useFirestore( 'images');
    const { getDisplayUrl, getFallbackUrls } = useImageSource();

    return (
        <div className='row mg'>
            {docs && docs.map(doc => {
                const displayUrl = getDisplayUrl(doc);
                if (!displayUrl) return null;
                const fallbacks = getFallbackUrls(doc);
                return (
                    <div className="img-wrap col-md-4" key={doc.id} onClick={() => { setSelectedImg(displayUrl); }} >
                        <Bounce top>
                        <img src={getThumbUrl(displayUrl)} alt="Uploaded Images" className='mx-2 my-3' loading="lazy"
                            onError={(e) => handleImageError(e, fallbacks)} />
                        </Bounce>
                    </div>
                );
            })}
        </div>
    )
}

export default ImageGrid